import { render, staticRenderFns } from "./VDashboardAccount.vue?vue&type=template&id=4e020f8b&"
import script from "./VDashboardAccount.vue?vue&type=script&lang=js&"
export * from "./VDashboardAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports